
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { ConnectionsManager } from '@/components/profile/ConnectionsManager';
import Header from '@/components/Header';
import MobileHeader from '@/components/mobile/MobileHeader';
import Footer from '@/components/Footer';
import { useIsMobile } from '@/hooks/useIsMobile';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';

const Connections = () => {
  const { user: supabaseUser } = useAuth();
  const { user: internalUser } = useInternalAuth();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  

  // Determine current user
  const currentUser = supabaseUser || internalUser;
  const currentUserType = supabaseUser ? 'supabase' : 'internal';
  const currentUserId = currentUser?.id;

  // Redirect if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {isMobile ? <MobileHeader /> : <Header />}
      <div className="min-h-screen bg-black text-white pt-20"> {/* Added pt-20 for fixed header */}
        <div className="container mx-auto px-4 py-8 max-w-6xl">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-sports-green mb-2">Connections</h1>
              <p className="text-gray-400">Manage your professional sports network</p>
              <Button
                onClick={() => navigate('/user-discovery')}
                className="mt-4 bg-sports-green text-black hover:bg-green-400 font-semibold"
              >
                <UserPlus className="h-4 w-4 mr-2" />
                Find Connections
              </Button>
            </div>

          {currentUserId && (
            <ConnectionsManager 
              userId={currentUserId} 
              userType={currentUserType}
            />
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Connections;
